<div class="simple-dialog-container">
  <!-- Close Icon -->
  <i [mat-dialog-close] class="fas fa-times close-icon"></i>

  <!-- Title -->
  <h2 *ngIf="data.title" class="dialog-title">{{ data.title }}</h2>

  <!-- Message -->
  <p *ngIf="data.message" class="dialog-message" [innerHTML]="data.message"></p>

  <!-- Actions -->
  <div class="dialog-actions">
    <!-- Cancel -->
    <button [mat-dialog-close] class="button cancel">Cerrar</button>
  </div>
</div>
